import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  progress: {
    color: theme.palette.secondary.main,
  },
}));

const LoadingButton = ({ showLoading, disabled, ...props }) => {
  const classes = useStyles();
  return (
    <Button disabled={showLoading || disabled} {...props}>
      {showLoading ? (
        <CircularProgress className={classes.progress} size={30} />
      ) : (
        props.children
      )}
    </Button>
  );
};

export default LoadingButton;
